"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "salara": {
    "argine-vecchio": [{
      "hkey": "2a206919",
      "slug": "salara",
      "name": "Salara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "287133b1": [{
      "hkey": "2a206919",
      "slug": "salara",
      "name": "Salara",
      "primary": true,
      "skipSearch": false
    }],
    "borgo": [{
      "hkey": "2a206919",
      "slug": "salara",
      "name": "Salara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba591573": [{
      "hkey": "2a206919",
      "slug": "salara",
      "name": "Salara",
      "primary": true,
      "skipSearch": false
    }],
    "coati": [{
      "hkey": "2a206919",
      "slug": "salara",
      "name": "Salara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "13401431": [{
      "hkey": "2a206919",
      "slug": "salara",
      "name": "Salara",
      "primary": true,
      "skipSearch": false
    }],
    "magherino": [{
      "hkey": "2a206919",
      "slug": "salara",
      "name": "Salara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7f4c0177": [{
      "hkey": "2a206919",
      "slug": "salara",
      "name": "Salara",
      "primary": true,
      "skipSearch": false
    }],
    "sabbioni": [{
      "hkey": "2a206919",
      "slug": "salara",
      "name": "Salara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d7cabead": [{
      "hkey": "2a206919",
      "slug": "salara",
      "name": "Salara",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;